import { render, staticRenderFns } from "./IconDots.vue?vue&type=template&id=91e154e0&"
import script from "./IconDots.vue?vue&type=script&lang=js&"
export * from "./IconDots.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('91e154e0')) {
      api.createRecord('91e154e0', component.options)
    } else {
      api.reload('91e154e0', component.options)
    }
    module.hot.accept("./IconDots.vue?vue&type=template&id=91e154e0&", function () {
      api.rerender('91e154e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/IconDots.vue"
export default component.exports